var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEvidenceHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2502 1.7998V4.4998C11.2502 4.99686 11.6531 5.3998 12.1502 5.3998H14.8502M6.30018 5.3998H8.10018M6.30018 8.0998H11.7002M6.30018 10.7998H11.7002M13.5002 3.1498C13.0996 2.79141 12.684 2.36634 12.4216 2.09026C12.247 1.90656 12.0057 1.7998 11.7523 1.7998H4.94997C3.95586 1.7998 3.14998 2.60569 3.14997 3.59979L3.1499 14.3998C3.1499 15.3939 3.95578 16.1998 4.94989 16.1998L13.0499 16.1998C14.044 16.1998 14.8499 15.3939 14.8499 14.3998L14.8502 4.85818C14.8502 4.62805 14.7624 4.40683 14.6027 4.24115C14.3073 3.93479 13.8141 3.43069 13.5002 3.1498Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvidenceHub);
export default __webpack_public_path__ + "static/media/IconEvidenceHub.deccf378cc2db4c47e149a1c833649ec.svg";
export { ForwardRef as ReactComponent };